module.exports = __webpack_public_path__ + "0489c39b1e06a46b21dbddf257de51c2.svg";